// extracted by mini-css-extract-plugin
module.exports = {"container":"ExportAnswersModale_container__10VAD"};